var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listado-texto',{attrs:{"tipos-lista":_vm.paises,"obras-por-tipo":_vm.obrasPorPais}})}
var staticRenderFns = []
export { render, staticRenderFns }